import { injectable } from "inversify";
import { IEnquiryFormService } from "../interfaces/enquiryFormService";
import { CreateEnquiryDto, ServiceResponse, EnquiryDto } from "../../platform/models";
import { ServiceResponseErrorCode } from "../../platform/enums";


@injectable()
class EnquiryFormService implements IEnquiryFormService {

    public async SubmitEnquiryForm(enquiryDto: CreateEnquiryDto, antiForgeryToken: string): Promise<ServiceResponse<EnquiryDto>> {
        try {
            const baseUrl = window.location.origin;
            const endpoint = '/api/enquiries';

            const response = await fetch(`${baseUrl}${endpoint}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'RequestVerificationToken': antiForgeryToken
                },
                body: JSON.stringify(enquiryDto)
            });

            const data = await response.json();

            if (!response.ok) {
                // Server returned validation errors or error response
                // data is typically the validation error collection itself
                if (Array.isArray(data) && data.length > 0) {
                    return new ServiceResponse<EnquiryDto>(
                        ServiceResponseErrorCode.ValidationError,
                        'Validation failed',
                        data
                    );
                }
                
                // Otherwise return generic error response
                return new ServiceResponse<EnquiryDto>(
                    response.status,
                    data.errorMessage || data.message || `HTTP ${response.status}: ${response.statusText}`
                );
            }

            return new ServiceResponse<EnquiryDto>(data);

        } catch (error) {
            return new ServiceResponse<EnquiryDto>(
                ServiceResponseErrorCode.SystemError,
                error.message || 'Enquiry submit error occurred'
            );
        }
    }
};

export { EnquiryFormService }